module.exports = __webpack_public_path__ + "img/SR.1895892f.png";